var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAudioConverter = function SvgIconAudioConverter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M4.958 13.577q.68 0 1.149-.47.47-.47.469-1.149V8.642h2.276V7.358H5.935v3.406a1.3 1.3 0 0 0-.441-.319 1.3 1.3 0 0 0-.536-.105q-.68 0-1.15.47-.468.47-.469 1.148 0 .68.47 1.15t1.149.469M1.513 15.5q-.576 0-.961-.385a1.3 1.3 0 0 1-.386-.96V1.844q0-.574.386-.96.386-.384.96-.385h6.57l3.75 3.75v9.904q0 .575-.384.961a1.3 1.3 0 0 1-.962.385zM7.666 4.667V1.333H1.513a.5.5 0 0 0-.354.16.49.49 0 0 0-.16.353v12.308q0 .191.16.353.16.16.353.16h8.975a.5.5 0 0 0 .352-.16.49.49 0 0 0 .16-.354V4.667z"
  })));
};
export default SvgIconAudioConverter;